<template>
    <div class="SalesDestination">
        <div class="SalesDestinationTitle" :title="Year + '/' + Month">
            {{ DistributorName }}
        </div>
        <div class="SalesCategories">
            <div class="SalesCategory" :title="Year + '/' + Month">
                <div class="SalesCategoryTitle RoundElement">
                    出荷
                </div>
            </div>
            <div class="SalesCategory" :title="Year + '/' + Month">
                <div class="SalesCategoryTitle RoundElement">
                    売上
                </div>
            </div>
            <div class="SalesCategory" :title="Year + '/' + Month">
                <div class="SalesCategoryTitle RoundElement">
                    利益
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        Year:Number,
        Month:Number,
        DistributorName:String
    }
}
</script>